/**
 * useModules - Hook para obter lista de módulos do sistema
 *
 * Fetches available modules from backend for permission UI
 */

import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { ModuleCategory, PermissionAction, PermissionScope } from '@troia-v3/types';

export interface ModuleDefinition {
  name: string;
  displayName: string;
  description: string;
  availableActions: PermissionAction[];
  requiresScope: boolean;
  defaultScope: PermissionScope;
  category: ModuleCategory;
  icon: string;
}

interface ModulesResponse {
  core: ModuleDefinition[];
  business: ModuleDefinition[];
  all: ModuleDefinition[];
}

/**
 * Hook to fetch all available modules from backend
 * Used in permission UI (levels, users)
 */
export const useModules = () => {
  return useQuery<ModulesResponse>({
    queryKey: ['modules'],
    queryFn: async () => {
      const response = await api.get<{ success: boolean; data: ModulesResponse }>('/modules');
      return response.data.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes - modules rarely change
    gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime in React Query v4)
  });
};
